"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsPickerMobile = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _NightsCounter = require("./NightsCounter");

var _MobileDropdown = require("../MobileDropdown");

var _SearcherFlexBadge = _interopRequireDefault(require("../SearcherFlexBadge"));

var _userflow = require("../../utils/userflow");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Components:
// Utils:
var NightsPickerMobile = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var nights = _ref.nights,
      _ref$flexNights = _ref.flexNights,
      flexNights = _ref$flexNights === void 0 ? false : _ref$flexNights,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 1 : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 30 : _ref$maxValue,
      _ref$onChangeNights = _ref.onChangeNights,
      onChangeNights = _ref$onChangeNights === void 0 ? function () {
    return undefined;
  } : _ref$onChangeNights,
      _ref$onChangeFlexNigh = _ref.onChangeFlexNights,
      onChangeFlexNights = _ref$onChangeFlexNigh === void 0 ? function () {
    return undefined;
  } : _ref$onChangeFlexNigh,
      _ref$showFlexNights = _ref.showFlexNights,
      showFlexNights = _ref$showFlexNights === void 0 ? true : _ref$showFlexNights,
      CustomControl = _ref.CustomControl,
      CustomLabel = _ref.CustomLabel;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)([nights, flexNights]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      changedValues = _useState2[0],
      setChangedValues = _useState2[1];

  var popupLabel = t('nightsPicker.duration');
  (0, _react.useEffect)(function () {
    var _changedValues = (0, _slicedToArray2["default"])(changedValues, 2),
        changedNights = _changedValues[0],
        changedFlexNights = _changedValues[1];

    if (nights !== changedNights || flexNights !== changedFlexNights) setChangedValues([nights, changedFlexNights]);
  }, [nights, flexNights]);

  var handleChange = function handleChange(val) {
    return setChangedValues([val, changedValues[1]]);
  };

  var handleChangeFlex = function handleChangeFlex() {
    return setChangedValues([changedValues[0], !changedValues[1]]);
  };

  var handleCancel = function handleCancel() {
    return setChangedValues([nights, flexNights]);
  };

  var handleSubmit = function handleSubmit() {
    var _changedValues2 = (0, _slicedToArray2["default"])(changedValues, 2),
        val = _changedValues2[0],
        isFlex = _changedValues2[1];

    if (flexNights !== isFlex) {
      onChangeFlexNights();
    }

    onChangeNights(val);
  };

  var Label = CustomControl ? CustomLabel : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "".concat(nights, " ").concat((0, _userflow.pluralize)(nights, _constants.NIGHTS_VALUES)), flexNights && /*#__PURE__*/_react["default"].createElement(StyledSearcherFlexBadge, null));
  return /*#__PURE__*/_react["default"].createElement(_MobileDropdown.MobileDropdown, {
    onCancel: handleCancel,
    onSubmit: handleSubmit,
    popupLabel: popupLabel,
    dropdownLabel: Label,
    CustomDropdownLabel: CustomControl
  }, /*#__PURE__*/_react["default"].createElement(_NightsCounter.NightsCounter, {
    value: changedValues[0],
    onValueChange: handleChange,
    minValue: minValue,
    maxValue: maxValue,
    showFlexNights: showFlexNights,
    checked: changedValues[1],
    onCheckedChange: handleChangeFlex,
    size: 36,
    isMobile: true
  }));
});

exports.NightsPickerMobile = NightsPickerMobile;
NightsPickerMobile.displayName = 'NightsPicker';
var StyledSearcherFlexBadge = (0, _styledComponents["default"])(_SearcherFlexBadge["default"]).withConfig({
  displayName: "NightsPickermobile__StyledSearcherFlexBadge",
  componentId: "sc-1py6g21-0"
})(["margin-left:5px;"]);